<!-- eslint-disable vue/multi-word-component-names -- component name is capitalised, and unlikely that html will introduce a similar tag -->
<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="journal-main">
    <div class="left-menu" ref="leftMenu">
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="right-container">
      <div class="top-section">
        <div class="filter-desc">{{ filterText }}</div>
        <ButtonFilter
          class="button-filter-component"
          filterPosition="right"
          buttonText="Change Filter"
          :filterWidth="300"
          :isOpen.sync="mainFilterIsOpen"
          :buttonIsDisabled="mainFilterIsDisabled"
        >
          <div class="filter-popup">
            <BoxContainer
              title="Date"
              :isCheckBox="true"
              style="margin-bottom: 5px"
              :isChecked.sync="filterJournalByDate"
            >
              <div>
                <DateTimePicker
                  placeholder="From"
                  :isRequired="filterJournalByDate"
                  :showTime="false"
                  :isDisabled="!filterJournalByDate"
                  :value.sync="journalListFromDate"
                  :errorMessage.sync="fromDateErrMsg"
                />
                <DateTimePicker
                  placeholder="To"
                  :isRequired="filterJournalByDate"
                  :showTime="false"
                  :isDisabled="!filterJournalByDate"
                  :value.sync="journalListToDate"
                  :errorMessage.sync="toDateErrMsg"
                />
              </div>
            </BoxContainer>
            <button @click="refreshClicked" :disabled="!filterJournalByDate">Refresh</button>
          </div>
        </ButtonFilter>
        <div>Last Refreshed: {{ lastRefreshed }}</div>
      </div>
      <div class="bottom-section">
        <TableBox
          title="Journal"
          :tableData="journalListing"
          :selectedRow.sync="selectedJournalEntry"
          :loading="journalEntryTableBoxLoading"
          :dataType="{ 'Total Amount': 'currency' }"
          style="height: 100%"
        />
      </div>
    </div>

    <PopupEntry
      v-if="showPopup"
      :show.sync="showPopup"
      :title="popupTitle"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      @save="saveClicked"
      :requiredError="requiredError"
      @requiredClicked="requiredClicked"
      :successMessages="successMessages"
      :errorMessages="errorMessages"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
      style="display: flex; flex-direction: row; justify-content: space-around; overflow: scroll"
      :canPrint="false"
    >
      <div class="journal-entries">
        <BoxContainer title="Journal Header" :isCollapsible="true" style="padding-bottom: 5px">
          <div class="journal-header">
            <div class="header-containers">
              <div style="display: flex; justify-content: space-between; width: 50%">
                <Input
                  placeholder="Batch No"
                  :inputValue.sync="batchNo"
                  :isRequired="true"
                  :isDisabled="true"
                  style="margin: 5px"
                />
                <Input
                  placeholder="Journal Date"
                  :inputValue.sync="journalDate"
                  :isDisabled="true"
                  style="margin: 5px"
                />
              </div>
              <Input
                placeholder="Description"
                :inputValue.sync="batchDescription"
                validator="text,200"
                :isDisabled="viewMode"
              />
            </div>
          </div>
        </BoxContainer>

        <div style="margin-top: 10px; height: 70%">
          <Tab
            :preventTabSwitch="true"
            :tabs="tabItems"
            :tabIndex.sync="currentTabIndex"
            @tabClicked="tabClicked"
            style="height: 100%"
          >
            <div slot="Details" class="tab-slot">
              <div class="tab-details-styling" :style="{ width: showTxnInput ? '50%' : '100%' }">
                <div class="tab-buttons">
                  <button v-if="!viewMode || action != ''" @click="openTxnInput" :isDisabled="showTxnInput"
                    >Add Details</button
                  >
                  <button v-if="!viewMode || action != ''" @click="deleteTxn">Delete Details</button>
                </div>
                <TableBox
                  title="Journal Details"
                  v-if="showJournalDetails"
                  :tableData="journalTxnDetails"
                  :selectedRow.sync="selectedJournalDetail"
                  :loading="journalTxnDetailsLoading"
                  :additionalButtons="tableButtons"
                  @buttonClicked="journalDetailsTblButtonClicked"
                  :maxSelection="1"
                  :hideColumns="journalTxnDetailsHideColumns"
                  :dataType="journalDetailsTblDataType"
                  style="height: calc(100% - 40px)"
                />
              </div>
              <div v-if="showTxnInput" class="side-entry-open" :style="{ width: showTxnInput ? '50%' : '0%' }">
                <div class="title-button">
                  <b>{{ viewMode || subtitleJL == '' ? 'Journal Detail' : subtitleJL }}</b>
                  <div class="buttons-arr">
                    <button @click="addEditDetailsClicked">{{ subAction == 'N' ? 'Add' : 'Edit' }} Detail</button>
                    <button @click="cancelDetailsClicked">Cancel</button>
                  </div>
                </div>
                <div>
                  <DateTimePicker
                    ref="txndate"
                    placeholder="Date"
                    :isRequired="true"
                    :showTime="false"
                    :isDisabled="viewMode"
                    :value.sync="txnDate"
                    :minDate="new Date('1900-01-01')"
                    :maxDate="new Date('2079-06-06')"
                    :errorMessage.sync="txnDateErr"
                    style="width: 30%"
                  />
                  <div style="display: flex">
                    <Dropdown
                      ref="partyType"
                      :placeholder="filteredPartyTypePlaceholder"
                      :items="filteredPartyType"
                      itemKey="type"
                      :selectedObject.sync="selectedPartyType"
                      @selected="partyTypeSelected"
                      :isRequired="true"
                      :isDisabled="viewMode"
                      :errorMessage.sync="partyTypeErr"
                      validator="text,50"
                    />
                    <InputQuery
                      ref="party"
                      :placeholder="partyTypePlaceholder"
                      :items="partyItemList"
                      :itemKey="partyItemKey"
                      :selectedObject.sync="selectedParty"
                      :isRequired="true"
                      :isDisabled="!selectedPartyType"
                      :errorMessage.sync="partyErr"
                      @selected="partyCodeSelected"
                      validator="text,10"
                    />
                  </div>
                  <div>
                    <InputQuery
                      ref="jobno"
                      placeholder="Job No"
                      :isRequired="jobNoRequired"
                      :items="jobNoList"
                      itemKey="Job No"
                      :selectedObject.sync="selectedJobNo"
                      :errorMessage.sync="jobNoErr"
                      :showRowLimit="true"
                      :rowLimitInputValue.sync="jobNoRowLimit"
                      @rowLimitFocusChanged="jobnoRowLimitChanged"
                      style="width: 50%"
                      validator="text,25"
                    />
                  </div>
                  <div style="display: flex">
                    <InputQuery
                      ref="dracc"
                      placeholder="Debit Acc"
                      :items="glAccList"
                      itemKey="Acc No"
                      :selectedObject.sync="selectedDrAcc"
                      :errorMessage.sync="drAccErr"
                      :isRequired="true"
                      :isDisabled="viewMode"
                      validator="text,20"
                    />
                    <InputQuery
                      ref="cracc"
                      placeholder="Credit Acc"
                      :items="glAccList"
                      itemKey="Acc No"
                      :selectedObject.sync="selectedCrAcc"
                      :errorMessage.sync="crAccErr"
                      :isRequired="true"
                      :isDisabled="viewMode"
                      validator="text,20"
                    />
                  </div>

                  <div style="display: flex">
                    <Dropdown
                      placeholder="Doc Type"
                      :items="offsetDocType"
                      itemKey="title"
                      :selectedObject.sync="selectedDocType"
                      :errorMessage.sync="docTypeErr"
                      @selected="docTypeSelected"
                      :isDisabled="offsetDocDisabled"
                    />
                    <InputQuery
                      placeholder="Offset Doc"
                      :items="offsetDocList"
                      itemKey="Doc No"
                      :selectedObject.sync="selectedOffsetDoc"
                      :errorMessage.sync="offsetDocErr"
                      :isDisabled="offsetDocDisabled || !selectedDocType"
                      :tableBoxDataType="offsetDocDataType"
                      @selected="offsetDocSelected"
                      :isRequired="selectedDocType != null"
                      :tableBoxHideColumns="['Ori Outstanding']"
                    />
                  </div>
                  <div class="foreign-currency-main" style="margin: 5px 0px">
                    <div class="foreign-currency-controls">
                      <BoxContainer background="rgba(225, 255, 255)">
                        <div class="foreign-currency-row">
                          <div class="foreign-currency-column">
                            <div class="foreign-currency-row">
                              <Input
                                placeholder="Outstanding Amt."
                                :inputValue="offsetDocOutstanding"
                                :isDisabled="true"
                                style="margin-left: 5px; margin-right: 10px"
                                validator="decimal,14,4"
                              />
                            </div>
                          </div>
                          <div class="foreign-currency-column">
                            <div class="foreign-currency-row">
                              <Input
                                placeholder="Amount"
                                :inputValue.sync="txnAmount"
                                :errorMessage.sync="txnAmountErr"
                                :isRequired="true"
                                :isDisabled="viewMode"
                                validator="decimal,14,4"
                                style="margin-left: 10px; margin-right: 5px"
                                @focusChanged="txnAmountFocusChanged"
                              />
                            </div>
                          </div>
                        </div>
                      </BoxContainer>
                    </div>
                    <div class="foreign-currency-background">
                      <div class="background-left"></div>
                      <div class="background-right"></div>
                    </div>
                  </div>
                  <div style="margin-right: 5px">
                    <RemarksBox
                      title="Remarks"
                      :text.sync="txnRemarks"
                      :maxLength="200"
                      :isDisabled="viewMode"
                      style="height: 75px"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div slot="Attachments" class="tab-slot">
              <div class="tab-details-styling" style="width: 100%">
                <div style="display: flex; justify-content: end; margin-top: 5px">
                  <button v-if="!viewMode" @click="openAttachmentPopup('new')" style="margin-right: 10px"
                    >Add Attachment</button
                  >
                  <button
                    v-if="!viewMode && attachmentsList.length > 0"
                    @click="openAttachmentPopup('edit')"
                    style="margin-right: 10px"
                    >Edit Attachment</button
                  >
                  <button
                    v-if="!viewMode && attachmentsList.length > 0"
                    @click="deleteAttachmentClicked"
                    style="margin-right: 10px"
                    >Del Attachment</button
                  >
                </div>
                <TableBox
                  v-if="showAttTable"
                  title="Attachment"
                  :tableData="attachmentsList"
                  :selectedRow.sync="selectedAtt"
                  :additionalButtons="[{ text: 'View', index: 0, width: 60 }]"
                  @buttonClicked="attAdditionalBtnsClicked"
                  :hideColumns="[
                    'Action',
                    'Doc Image',
                    'Sequence No',
                    'Document GUID',
                    'ID',
                    'Doc Ref No',
                    'Job No',
                    'Doc Code',
                    'Doc Type',
                    'Doc Rec Date',
                    'Doc Rec Time',
                    '_attachmentAction',
                  ]"
                  :dataType="{ 'Doc Date': 'date' }"
                />
              </div>
            </div>
          </Tab>
        </div>

        <BoxContainer
          title="Show Journal Items for Doc"
          :isCollapsible="true"
          :isCollapsed.sync="journalItemsIsCollapsed"
        >
          <div style="display: flex; justify-content: space-between; width: 50%">
            <Dropdown
              placeholder="Doc Type"
              :items="docType"
              itemKey="title"
              :selectedObject.sync="selectedJournalItemType"
              @selected="journalItemDocTypeSelected"
              style="margin: 5px; width: 50%"
            />
            <InputQuery
              placeholder="Doc No"
              :items="selectedJournalItemType ? journalItems[selectedJournalItemType['type']] : journalItems['JV']"
              itemKey="Ref No"
              descKey="Journal No"
              :showDesc="true"
              :isDisabled="!selectedJournalItemType"
              :selectedObject.sync="selectedJournalItemDoc"
              @selected="journalItemDocSelected"
              style="margin: 5px; width: 50%"
            />
          </div>
          <TableBox title="Journal Items" :tableData="journalItemDetails" :loading="journalItemsLoading" />
        </BoxContainer>
      </div>
      <BoxContainer>
        <div style="display: flex; flex-direction: row; justify-content: flex-end">
          <div style="display: flex; margin-right: 20px">
            <div style="align-content: center; margin-right: 10px; font-size: 1.1em">Total</div>
            <div style="display: flex">
              <div class="total-block" style="font-size: 1.2em; font-weight: bold">MYR {{ journalTotalAmt }}</div>
            </div>
          </div>
        </div>
      </BoxContainer>
    </PopupEntry>

    <!-- <PopupV2
      :show="showDeleteJournal"
      title="Delete Journal"
      @buttonClicked="deletePopupClicked"
      :buttons="deletePopupButtons"
    >
      <div
        >Please state reason to delete
        {{ selectedJournalEntry.length > 0 ? selectedJournalEntry[0]['Batch No'] : '' }}?</div
      >
      <Input
        placeholder="Delete Remarks"
        :inputValue.sync="deleteJournalRemarks"
        :errorMessage.sync="deleteJournalRemarksErr"
        :isRequired="true"
        validator="text,100"
      />
    </PopupV2> -->

    <div class="attachments-popup-container">
      <PopupV2
        class="attachments-popup"
        :show="showAttachmentsPopup"
        :title="attachmentsPopupTitle"
        :buttons="attachmentsPopupButtons"
        @buttonClicked="attachmentsPopupBtnsClicked"
      >
        <div class="attachments-popup-content">
          <Input
            textType="file"
            placeholder="Select File"
            ref="docFile"
            :isDisabled="viewMode"
            :inputValue.sync="documents['docName']"
            @fileChanged="handleFileUpload"
            :errorMessage.sync="attachmentsRequiredErrorMessage"
          />
          <div v-if="attachmentsAction == 'E'" class="attached-file">
            <strong>Attached file: </strong>
            <span
              class="file-link"
              title="Click to view"
              @click="
                projectAttachment({
                  'File Name': selectedAtt.length > 0 ? selectedAtt[0]['File Name'] : '',
                  'MIME Type': null,
                  'File Data': selectedAtt.length > 0 ? selectedAtt[0]['Doc Image'] : '',
                })
              "
            >
              {{ selectedAtt.length > 0 ? selectedAtt[0]['File Name'] : '' }}
            </span>
          </div>
          <RemarksBox
            :maxLength="200"
            style="height: 50%"
            title="Remarks"
            :isDisabled="viewMode"
            :text.sync="documents['remarks']"
          />
        </div>
      </PopupV2>
    </div>
    <div v-if="showAttachmentProjector" class="attachment-projector">
      <div class="attachment-projection">
        <object
          v-if="isProjectable"
          :data="attachmentProjectorData"
          :type="attachmentProjectorType"
          draggable="false"
        ></object>
        <div v-else class="attachment-not-projectable-container">
          <span>
            {{ selectedAtt[0]['File Type'].replaceAll('.', '').toUpperCase() }} files cannot be previewed. <br />
            Please download the file and view it instead.
          </span>
          <button @click="downloadAttachment">
            <img src="https://dsmlib.logistics.systems/Icons/Download.png" alt="Download icon" />
            Download
          </button>
        </div>
      </div>
      <div class="close-button" @click="closeProjector"> &times; </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    tableButtons: function () {
      return this.action == '' ? [] : [{ text: 'Edit', index: 0, width: 80 }];
    },

    partyTypePlaceholder: function () {
      if (this.selectedPartyType) {
        switch (this.selectedPartyType['apiKey']) {
          case '0':
            return 'Debtor';
          case '1':
            return 'Creditor';
          case '2':
            return 'Charges Code';
          default:
            return '';
        }
      }
      return 'Debtor';
    },

    filteredPartyType: function () {
      return this.partyType.filter((r) => r['enabled']);
    },

    filteredPartyTypePlaceholder: function () {
      const filtered = this.partyType.filter((r) => r['enabled']);
      return filtered.map((f) => f['type']).join(' / ');
    },

    partyItemList: function () {
      if (this.selectedPartyType) {
        switch (this.selectedPartyType['apiKey']) {
          case '0':
            return this.debtorList;
          case '1':
            return this.creditorList;
          case '2':
            return this.groupCodeList;
          default:
            return [];
        }
      }
      return this.debtorList;
    },

    partyItemKey: function () {
      if (this.selectedPartyType) {
        switch (this.selectedPartyType['apiKey']) {
          case '0':
            return 'Customer Code';
          case '1':
            return 'Creditor Code';
          case '2':
            return 'Charges Code';
          default:
            return '';
        }
      }
      return 'Customer Code';
    },

    jobNoRequired: function () {
      return this.selectedPartyType && this.selectedPartyType['apiKey'] == '2';
    },

    offsetDocDisabled: function () {
      return (
        this.viewMode ||
        !this.selectedPartyType ||
        !this.selectedParty ||
        (this.selectedPartyType && this.selectedPartyType['apiKey'] == '2')
      );
    },

    offsetDocType: function () {
      if (!this.selectedPartyType) return;
      switch (this.selectedPartyType['apiKey']) {
        case '0':
          return this.docType.filter((d) => d['category'] && d['category'].includes('D'));
        case '1':
        case '2':
          return this.docType.filter((d) => d['category'] && d['category'].includes('C'));
        default:
          return [];
      }
    },

    journalTxnDetailsHideColumns: function () {
      const columns = ['BatchNo', 'TxnInd', 'Txn', 'SaveAmount', 'Action'];
      const recovery = this.partyType.find((p) => p['apiKey'] == '2');
      if (!recovery.enabled) columns.push('Charges Code');
      return columns;
    },
  },
  data: function () {
    return {
      menu: [
        {
          title: 'New Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: false,
          key: 'mnuNew',
        },
        {
          title: 'Edit Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          key: 'mnuEdit',
        },
        {
          title: 'Delete Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: false,
          key: 'cmdDelete',
        },
        {
          title: 'View Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
        },
        {
          title: 'Print Journal',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
          key: 'mnuJournal',
        },
      ],

      filterText: '',
      mainFilterIsOpen: false,
      mainFilterIsDisabled: false,
      filterJournalByDate: true,
      journalListFromDate: new Date(),
      fromDateErrMsg: '',
      journalListToDate: new Date(),
      toDateErrMsg: '',
      lastRefreshed: '',

      journalListing: [],
      selectedJournalEntry: [],
      journalEntryTableBoxLoading: false,

      showPopup: false,
      popupTitle: '',
      viewMode: false,
      action: '',

      createdBy: '',
      updatedBy: '',
      requiredError: [],
      successMessages: [],
      errorMessages: [],

      debtorCtrlAcc: '',
      creditorCtrlAcc: '',
      gainAcc: '',
      lossAcc: '',

      //#region Lists
      // D: Debtor, C: Creditor
      docType: [
        { title: 'JV - Journal', type: 'JV', apiKey: '0', category: 'DC' },
        { title: 'IN - Invoice', type: 'IN', apiKey: '1', category: 'D' },
        { title: 'DN - Debit Note', type: 'DN', apiKey: '2', category: 'D' },
        { title: 'CN - Credit Note', type: 'CN', apiKey: '3', category: 'D' },
        { title: 'RT - Receipt', type: 'RT', apiKey: '6', category: 'D' },
        { title: 'APIN - AP Invoice', type: 'APIN', apiKey: '4', category: 'C' },
        { title: 'APCN - AP Credit Note', type: 'APCN', apiKey: '5', category: 'C' },
      ],
      partyType: [
        { type: 'Debtor', apiKey: '0', enabled: true },
        { type: 'Creditor', apiKey: '1', enabled: true },
        { type: 'Recovery', apiKey: '2', enabled: true },
      ],
      journalItems: {
        JV: [],
        IN: [],
        DN: [],
        CN: [],
        RT: [],
        APIN: [],
        APCN: [],
      },
      debtorList: [],
      creditorList: [],
      groupCodeList: [],
      jobNoList: [],
      jobNoRowLimit: '1000',
      glAccList: [],
      offsetDocList: [],
      offsetDocDataType: {
        'Outstanding Amount': 'currency',
        'Total Amount': 'currency',
      },
      //#endregion

      //#region Show Journal Items for Doc
      selectedJournalItemType: null,
      selectedJournalItemDoc: null,
      journalItemsLoading: false,
      journalItemDetails: [],
      journalItemsIsCollapsed: true,
      //#endregion

      tabItems: [
        { title: 'Details', disabled: false },
        { title: 'Attachments', disabled: false },
      ],
      currentTabIndex: 0,

      batchNo: '',
      journalDate: '',
      batchDescription: '',
      showJournalDetails: true,
      journalTxnDetails: [],
      deletedJournalTxnDetails: [],
      selectedJournalDetail: [],
      journalTxnDetailsLoading: false,
      journalDetailsTblDataType: {
        Date: 'date',
        Amount: 'currency',
        SaveAmount: 'currency',
      },
      showTxnInput: false,
      subtitleJL: '',
      subAction: '',
      journalTotalAmt: '0.00',

      selectedPartyType: null,
      partyTypeErr: '',
      selectedParty: null,
      partyErr: '',
      txnDate: null,
      txnDateErr: '',
      selectedDrAcc: null,
      drAccErr: '',
      selectedCrAcc: null,
      crAccErr: '',
      selectedDocType: null,
      docTypeErr: '',
      selectedOffsetDoc: null,
      offsetDocErr: '',
      offsetDocOutstanding: '',
      txnAmount: '0.0000',
      txnAmountErr: '',
      txnRemarks: '',
      selectedJobNo: null,
      jobNoErr: '',

      // showDeleteJournal: false,
      // deletePopupButtons: [
      //   { text: 'Delete', color: 'indianred', textColor: 'white' },
      //   { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      // ],
      // deleteJournalRemarks: '',
      // deleteJournalRemarksErr: '',

      //#region Attachments
      attachmentsList: [],
      deletedAttList: [],
      showAttTable: true,
      selectedAtt: [],
      showAttachmentsPopup: false,
      attachmentsPopupTitle: '',
      attachmentsPopupButtons: [],
      documents: {
        docName: '',
        attachmentFile: [],
        filetype: '',
        docGuid: '',
        remarks: '',
        docID: 0,
      },
      oldDoc: '',
      attachmentsAction: '', // 'N', 'E', 'V'
      attachmentsRequiredErrorMessage: '',
      showAttachmentProjector: false,
      isProjectable: false,
      attachmentProjectorFileName: '',
      attachmentProjectorData: '',
      attachmentProjectorType: '',
      //#endregion
    };
  },
  props: {},
  methods: {
    menuClicked: async function (e) {
      this.clearAllData();
      this.mainFilterIsOpen = false;
      this.currentTabIndex = 0;

      switch (e['title']) {
        case 'New Journal': {
          this.action = 'N';
          this.popupTitle = e['title'];
          this.batchNo = '**********';
          this.viewMode = false;
          this.showPopup = true;
          break;
        }

        case 'Edit Journal': {
          if (this.selectedJournalEntry.length == 0) {
            this.$showAlert('error', 'No Journal Selected', 'Please select a journal to edit.');
            return;
          } else if (this.selectedJournalEntry[0]['Status'] == 'C') {
            this.$showAlert(
              'error',
              'Selected Journal Already Cancelled',
              'You are not allowed to edit cancelled journal',
            );
            return;
          } else if (this.selectedJournalEntry[0]['ReachME'] == '1') {
            this.$showAlert(
              'error',
              'Selected Journal Already Reach GL Month End',
              'You are not allowed to edit this journal',
            );
            return;
          } else if (this.selectedJournalEntry[0]['IsClose'] == '1') {
            this.$showAlert(
              // tbc
              'warning',
              'Month End Already Processed',
              'User can only offset documents.',
            );
            return;
          }
          this.action = 'E';
          this.$nextTick(async () => {
            await this.populateJournalDetails(
              this.selectedJournalEntry[0]['Batch No'],
              this.selectedJournalEntry[0]['FYear'],
            );
            this.showPopup = true;
          });
          this.viewMode = false;
          this.popupTitle = e['title'];
          break;
        }

        case 'View Journal': {
          if (this.selectedJournalEntry.length == 0) {
            this.$showAlert('error', 'No Journal Selected', 'Please select a journal to view.');
            return;
          }
          this.action = '';
          this.$nextTick(async () => {
            await this.populateJournalDetails(
              this.selectedJournalEntry[0]['Batch No'],
              this.selectedJournalEntry[0]['FYear'],
            );
          });
          this.viewMode = true;
          this.popupTitle = e['title'];
          this.showPopup = true;
          break;
        }

        case 'Delete Journal': {
          if (this.selectedJournalEntry.length == 0) {
            this.$showAlert('error', 'No Journal Selected', 'Please select a journal to delete.');
            return;
          } else if (this.selectedJournalEntry[0]['Status'] == 'C') {
            this.$showAlert(
              'error',
              'Selected Journal Already Cancelled',
              'You are not allowed to delete cancelled journal',
            );
            return;
          } else if (this.selectedJournalEntry[0]['ReachME'] == '1') {
            this.$showAlert(
              'error',
              'Selected Journal Already Reach GL Month End',
              'You are not allowed to delete this journal',
            );
            return;
          } else if (this.selectedJournalEntry[0]['IsClose'] == '1') {
            this.$showAlert(
              // tbc
              'warning',
              'Month End Already Processed',
              'User can only offset documents.',
            );
            return;
          }
          const confirmDelete = await this.$showAlert(
            'warning',
            `Delete Journal ${this.selectedJournalEntry[0]['Batch No']}`,
            'Are you sure you want to delete this journal?',
            [{ text: 'Yes', color: 'red', textColor: 'white' }, { text: 'No' }],
          );

          if (confirmDelete == 'Yes') {
            await this.deleteJournal();
          }
          break;
        }
      }
    },

    refreshClicked: async function () {
      let journalListingErr = false;
      if (this.filterJournalByDate) {
        if (!this.journalListFromDate) {
          this.fromDateErrMsg = 'Enter from date!';
          journalListingErr = true;
        }

        if (!this.journalListToDate) {
          this.toDateErrMsg = 'Enter to date!';
          journalListingErr = true;
        }
      }
      if (journalListingErr) return;

      this.mainFilterIsOpen = false;
      const dataToPost = {
        startdate: this.journalListFromDate ? new Date(this.journalListFromDate).formatString('yyyy-MM-dd') : '',
        enddate: this.journalListToDate ? new Date(this.journalListToDate).formatString('yyyy-MM-dd') : '',
      };

      this.filterText = 'Filter by ';
      if (this.filterJournalByDate) {
        this.filterText += `date from ${this.journalListFromDate.formatString('yyyy-MM-dd')} to ${this.journalListToDate.formatString('yyyy-MM-dd')}`;
      }

      this.$fullscreenLoading('Getting Journal Listing');
      this.journalEntryTableBoxLoading = true;
      this.journalListing = [];
      this.journalListing = await this.$apiCallV2('/Journal/GetJournalListing', dataToPost);
      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');
      this.journalEntryTableBoxLoading = false;
      this.$fullscreenLoading();
    },

    requiredClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },

    saveClicked: async function () {
      this.errorMessages = [];
      this.successMessages = [];
      this.requiredError = [];

      if (this.showTxnInput) {
        const discard = await this.promptDiscardTxnDetInput();
        if (discard === 'Cancel') return;

        this.$nextTick(() => {
          this.showTxnInput = false;
          this.clearAllDetailsData();
        });
      }

      if (this.journalTxnDetails.length == 0) {
        this.$showAlert('error', 'No Journal Details', 'Please add at least one transaction to save.');
        return;
      }

      const allTxnDet = this.journalTxnDetails.concat(this.deletedJournalTxnDetails);
      const txnDetToSave = allTxnDet.map((txn) => {
        return {
          action: txn['Action'] || '',
          seqno: txn['Seq No'] || '',
          txndate: txn['Txn Date'] ? new Date(txn['Txn Date']).formatString('yyyy-MM-dd') : '',
          debtor: txn['Debtor'] ?? '',
          creditor: txn['Creditor'] ?? '',
          debitacc: txn['Debit Acc'] ?? '',
          creditacc: txn['Credit Acc'] ?? '',
          txnamt: txn['Amount'] ?? '0.00',
          remarks: txn['Remarks'] || '',
          refno: txn['Offset Doc'] || '',
          txn: txn['Txn'] ?? '0',
          txnind: txn['TxnInd'] ?? '2',
          jobno: txn['Job No'] ?? '',
          chargescode: txn['Charges Code'] ?? '',
        };
      });

      const allAttachments = this.attachmentsList.concat(this.deletedAttList);
      const attachmentsToSave = allAttachments.map((doc) => {
        return {
          doccode: 'ATT',
          docrefno: '',
          remarks: doc['Doc Remark'],
          status: '',
          docname: doc['File Name'],
          docimage: doc['Doc Image'],
          docimagetype: doc['File Type'],
          action: doc['Action'] ?? this.action,
          docguid: this.action == 'N' ? '' : doc['Document GUID'],
        };
      });

      const dateSplit = this.journalDate.split('/');
      const batchDate = new Date(Number(dateSplit[1]), Number(dateSplit[0]), 0).formatString('yyyy-MM-dd');
      const dataToSave = {
        action: this.action,
        batchno: this.action == 'N' ? '' : this.batchNo.trim(),
        batchdate: batchDate || new Date().formatString('yyyy-MM-dd'),
        batchname: this.batchDescription || '',
        totalamt: this.journalTotalAmt || '0.00',
        noofentry: this.journalTxnDetails.length,
        journaldetails: txnDetToSave || [],
        attachments: attachmentsToSave || [],
      };

      this.$fullscreenLoading('Saving Journal');
      const result = await this.$apiCallV2('/Journal/SaveJournal', dataToSave);
      this.$fullscreenLoading();

      if (result[0]['Results'] != 0) {
        if (this.action == 'N') {
          this.errorMessages.push(`There was an error creating Journal: ${result[0]['ErrMsg']}`);
        } else {
          this.errorMessages.push(`There was an error editing Journal: ${result[0]['ErrMsg']}`);
        }
        return;
      }

      this.showJournalDetails = false;
      this.showAttTable = false;
      this.clearAllData();
      const resultValues = result[0]['Batch No'].split(',');
      this.$nextTick(async () => {
        await this.populateJournalDetails(resultValues[0], resultValues[1]);
        this.showJournalDetails = true;
        this.showAttTable = true;
        await this.refreshClicked();
      });

      this.successMessages.push(`${result[0]['ErrMsg']}`);
      this.viewMode = true;
      this.popupTitle = 'View Journal';
      this.action = '';
    },

    tabClicked: async function (_tabItem, tabIndex) {
      if (this.showTxnInput && tabIndex != 0) {
        const discard = await this.promptDiscardTxnDetInput();
        if (discard === 'Cancel') {
          return;
        }
        this.$nextTick(() => {
          this.showTxnInput = false;
          this.clearAllDetailsData();
        });
      }
      this.currentTabIndex = tabIndex;
    },

    promptDiscardTxnDetInput: async function () {
      return await this.$showAlert('warning', 'Journal Detail not saved yet', 'Do you wish to discard the changes?', [
        { text: 'Discard', color: 'Red', textColor: 'white' },
        { text: 'Cancel' },
      ]);
    },

    clearAllData: function () {
      this.batchNo = '';
      this.journalDate = '';
      this.batchDescription = '';

      this.selectedJournalDetail = [];
      this.showTxnInput = false;
      this.subtitleJL = '';
      this.subAction = '';

      this.journalTxnDetails = [];
      this.deletedJournalTxnDetails = [];
      this.attachmentsList = [];

      this.clearAllMessages();
      this.clearAllDetailsData();
      this.clearAllAttData();
    },

    clearAllMessages: function () {
      this.requiredError = [];
      this.successMessages = [];
      this.errorMessages = [];
    },

    clearAllDetailsData: function () {
      this.selectedPartyType = null;
      this.partyTypeErr = '';
      this.selectedParty = null;
      this.partyErr = '';
      this.txnDate = null;
      this.txnDateErr = '';
      this.selectedDrAcc = null;
      this.drAccErr = '';
      this.selectedCrAcc = null;
      this.crAccErr = '';
      this.selectedDocType = null;
      this.docTypeErr = '';
      this.selectedOffsetDoc = null;
      this.offsetDocErr = '';
      this.txnAmount = '0.0000';
      this.txnAmountErr = '';
      this.txnRemarks = '';
      this.offsetDocOutstanding = '';
    },

    clearAllAttData: function () {
      this.documents = {
        docName: '',
        attachmentFile: [],
        filetype: '',
        docGuid: '',
        remarks: '',
        docID: 0,
      };
      this.attachmentsRequiredErrorMessage = '';
    },

    populateJournalDetails: async function (batchNo, fYear) {
      this.$fullscreenLoading('Getting Journal Details');
      const journalDetails = (
        await this.$apiCallV2('/Journal/GetJournalDetails', {
          batchno: batchNo,
          fyear: fYear,
        })
      )['Journal']['TxnHdr'];

      this.batchNo = journalDetails['BatchNo'] || '';
      this.journalDate = journalDetails['SysDate'] ? new Date(journalDetails['SysDate']).formatString('MM/yyyy') : '';
      this.batchDescription = journalDetails['Description'] || '';
      this.journalTotalAmt = this.$currencyFormat(journalDetails['Total'] || 0);
      this.createdBy =
        journalDetails['CreatedBy'] ?
          `${journalDetails['CreatedBy']} ${journalDetails['TimeCreated'] != '' ? new Date(journalDetails['TimeCreated']).formatString('yyyy-MM-dd HH:mm') : ''}`
        : '';
      this.updatedBy =
        journalDetails['UpdatedBy'] ?
          `${journalDetails['UpdatedBy']} ${new Date(journalDetails['DateUpdated']).formatString('yyyy-MM-dd HH:mm')}`
        : '';

      this.journalTxnDetails = journalDetails['TxnDet'] || [];
      this.attachmentsList = journalDetails['Attachments'] || [];
      this.$fullscreenLoading();
    },

    getOffsetDocs: async function (docType, partyType, partyCode) {
      const dataToPost = {
        doctype: docType ?? '0',
        payeetype: partyType ?? '0',
        debtcred: partyCode ?? '',
        category: '0',
        batchno: this.action == 'N' ? '' : this.batchNo.trim(),
      };
      let offsetDocs = await this.$apiCallV2('/Journal/GetJournalDocLists', dataToPost);
      offsetDocs = offsetDocs.map((doc) => {
        return {
          ...doc,
          'Ori Outstanding': doc['Outstanding Amount'],
        };
      });

      // Have to calculate the updated outstanding amount to show the actual outstanding after other offsets that have not been save into database
      // value involved: actual outstanding (retrieved from db),
      if (this.journalTxnDetails.length == 0 && this.journalTxnDetails.every((txn) => txn['Offset Doc'] == ''))
        return offsetDocs;

      const tempOffsetDocs = offsetDocs;
      for (const doc of tempOffsetDocs) {
        const docNo = doc['Doc No'];
        const sameOffsetDoc = this.journalTxnDetails.filter(
          (txn) =>
            txn['Offset Doc'] == docNo &&
            ['0', '1'].includes(txn['TxnInd']) &&
            (txn['Action'] == 'E' || txn['Action'] == 'N'),
        );
        if (sameOffsetDoc.length == 0) continue;
        let currentOffsetAmt = 0;

        if (['1', '2', '5'].includes(docType) || (docType == '0' && doc['TxnInd'] == '0')) {
          currentOffsetAmt = sameOffsetDoc.reduce(
            (acc, curr) => acc + Number(curr['Amount']) * (curr['TxnInd'] == '0' ? 1 : -1),
            0,
          );
        } else {
          currentOffsetAmt = sameOffsetDoc.reduce(
            (acc, curr) => acc + Number(curr['Amount']) * (curr['TxnInd'] == '1' ? 1 : -1),
            0,
          );
        }

        if (docType != '0') {
          if (this.selectedJournalDetail.length > 0 && this.selectedJournalDetail[0]['Offset Doc'] == docNo) {
            const selectedOffsetAmt = Number(this.selectedJournalDetail[0]['Amount']);
            if (['1', '2', '5'].includes(docType) || (docType == '0' && doc['TxnInd'] == '0')) {
              currentOffsetAmt += selectedOffsetAmt * (this.selectedJournalDetail[0]['TxnInd'] == '0' ? -1 : 1);
            } else {
              currentOffsetAmt += selectedOffsetAmt * (this.selectedJournalDetail[0]['TxnInd'] == '1' ? -1 : 1);
            }
          }
        }
        doc['Outstanding Amount'] = Number(doc['Ori Outstanding']) + currentOffsetAmt;
      }
      // remove added journals
      return tempOffsetDocs.filter((doc) => Number(doc['Outstanding Amount']) != 0);
    },

    deleteJournal: async function () {
      this.$fullscreenLoading('Deleting Selected Journal');
      const journalDetails = (
        await this.$apiCallV2('/Journal/GetJournalDetails', {
          batchno: this.selectedJournalEntry[0]['Batch No'],
          fyear: this.selectedJournalEntry[0]['FYear'],
        })
      )['Journal']['TxnHdr'];
      const txnDet = journalDetails['TxnDet'] || [];
      const detToDelete = txnDet.map((d) => {
        return {
          action: 'D',
          seqno: d['Seq No'],
          txndate: d['Txn Date'],
          debtor: d['Debtor'],
          creditor: d['Creditor'],
          debitacc: d['Debit Acc'],
          creditacc: d['Credit Acc'],
          txnamt: d['Amount'],
          remarks: d['Remarks'],
          refno: d['Offset Doc'] || '',
          txn: d['Txn'],
          txnind: d['TxnInd'],
          jobno: d['Job No'],
          chargescode: d['Charges Code'],
        };
      });

      const deleteBody = {
        action: 'D',
        batchno: this.selectedJournalEntry[0]['Batch No'],
        batchdate: new Date(journalDetails['SysDate']).formatString('yyyy-MM-dd'),
        journaldetails: detToDelete || [],
      };

      const deleteResult = await this.$apiCallV2('/Journal/SaveJournal', deleteBody);
      this.$fullscreenLoading();

      if (deleteResult[0]['Results'] == 0) {
        this.$showAlert(
          'success',
          'Deleted!',
          `Journal ${this.selectedJournalEntry[0]['Batch No']} was successfully deleted.`,
        );
        this.journalListing = [];
        this.selectedJournalEntry = [];
        this.$nextTick(async () => {
          await this.refreshClicked();
        });
      } else {
        await this.$showAlert('error', 'Delete Unsuccessful', `${deleteResult[0]['ErrMsg']}`);
        this.journalListing = [];
        this.selectedJournalEntry = [];
        this.$nextTick(async () => {
          await this.refreshClicked();
        });
      }
    },

    //#region InputQuery/Dropdown selected
    journalItemDocTypeSelected: function (newType, oldType) {
      if (oldType && newType['apiKey'] == oldType['apiKey']) return;
      this.selectedJournalItemDoc = null;
    },

    journalItemDocSelected: async function (docNo) {
      if (!docNo) return;
      this.$fullscreenLoading('Getting Journal Items');
      this.journalItemDetails = [];
      this.journalItemsLoading = true;
      const dataToPost = {
        doctype: this.selectedJournalItemType['apiKey'],
        refno: docNo['Journal No'],
      };
      const items = await this.$apiCallV2('/Journal/GetJournalItems', dataToPost);
      this.$nextTick(() => {
        this.journalItemDetails = items;
      });
      this.journalItemsLoading = false;
      this.$fullscreenLoading();
    },

    partyTypeSelected: function (newType, oldType) {
      if (oldType && newType['apiKey'] == oldType['apiKey']) return;
      this.selectedParty = null;
      this.partyErr = '';
      this.selectedOffsetDoc = null;
      if (newType['apiKey'] == '0') {
        this.selectedCrAcc = this.glAccList.find((acc) => acc['Acc No'] == this.debtorCtrlAcc);
        this.selectedDrAcc = null;
      } else if (newType['apiKey'] == '1') {
        this.selectedDrAcc = this.glAccList.find((acc) => acc['Acc No'] == this.creditorCtrlAcc);
        this.selectedCrAcc = null;
      }
    },

    partyCodeSelected: async function (partyCode) {
      if (!partyCode) {
        this.selectedOffsetDoc = null;
        return;
      }
      if (this.selectedPartyType['apiKey'] == '2') return;
      if (this.selectedPartyType['apiKey'] == '0') {
        // debtor
        this.selectedCrAcc = this.glAccList.find((acc) => acc['Acc No'] == partyCode['GL Acc']);
        // this.selectedDrAcc = null;
      } else if (this.selectedPartyType['apiKey'] == '1') {
        // creditor
        this.selectedDrAcc = this.glAccList.find((acc) => acc['Acc No'] == partyCode['GL Acc']);
        // this.selectedCrAcc = null;
      }

      if (this.selectedDocType) {
        this.$fullscreenLoading('Getting Offset Docs');
        this.offsetDocList = [];
        this.offsetDocList = await this.getOffsetDocs(
          this.selectedDocType['apiKey'],
          this.selectedPartyType['apiKey'],
          partyCode[this.partyItemKey],
        );
        this.selectedOffsetDoc = null;
        this.$fullscreenLoading();
      }
    },

    docTypeSelected: async function (newType, oldType) {
      if (oldType && newType['apiKey'] == oldType['apiKey']) return;

      this.$fullscreenLoading('Getting Offset Docs');
      this.offsetDocList = [];
      this.offsetDocList = await this.getOffsetDocs(
        newType['apiKey'],
        this.selectedPartyType['apiKey'],
        this.selectedParty[this.partyItemKey],
      );
      this.selectedOffsetDoc = null;
      this.$fullscreenLoading();
    },

    offsetDocSelected: function (doc) {
      if (!doc) return;
      this.offsetDocOutstanding = parseFloat(doc['Outstanding Amount']).toFixed(2) || '0.0000';
    },
    //#endregion

    //#region Transaction Input
    updateJournalTotal: function () {
      if (this.journalTxnDetails.length == 0) {
        this.journalTotalAmt = '0.00';
        return;
      }
      const total = this.journalTxnDetails.reduce((acc, amt) => acc + Number(amt['Amount']), 0);
      this.journalTotalAmt = this.$currencyFormat(total);
    },

    openTxnInput: function () {
      this.clearAllDetailsData();
      this.showTxnInput = true;
      this.subAction = 'N';
      this.subtitleJL = 'Add Journal Detail';
      this.txnDate = new Date();
      this.$nextTick(() => {
        this.$refs['partyType'].setFocus();
      });
    },

    deleteTxn: async function () {
      if (this.selectedJournalDetail.length == 0) {
        await this.$showAlert(
          'error',
          'No Journal Details Selected',
          'Please select at least 1 journal detail to delete.',
        );
        return;
      }

      const confirmCancel = await this.$showAlert(
        'warning',
        'Deleting Journal Transaction',
        `Are you sure you want to delete this transaction ?`,
        [
          { text: 'Yes', color: 'indianred', textColor: 'white' },
          { text: 'No', color: 'lightgray', textColor: 'black' },
        ],
      );
      if (confirmCancel == 'No') return;

      let temp = [];
      if (this.selectedJournalDetail[0]['Action'] && this.selectedJournalDetail[0]['Action'] == 'N') {
        temp = this.journalTxnDetails.filter((txn) => txn['Seq No'] != this.selectedJournalDetail[0]['Seq No']);
      } else {
        this.journalTxnDetails.forEach((txn) => {
          if (txn['Seq No'] == this.selectedJournalDetail[0]['Seq No']) {
            txn['Action'] = 'D';
            this.deletedJournalTxnDetails.push(txn);
          }
        });
        temp = this.journalTxnDetails.filter((txn) => txn['Action'] != 'D');
      }

      this.journalTxnDetails = [];
      this.showJournalDetails = false;
      this.$nextTick(() => {
        this.journalTxnDetails = temp;
        this.selectedJournalDetail = [];
        this.clearAllDetailsData();
        this.showJournalDetails = true;
        this.updateJournalTotal();
      });
    },

    journalDetailsTblButtonClicked: async function (_btn, data) {
      if ((!data['Action'] || data['Action'] == '') && data['Offset Doc'].trim() != '') {
        this.$showAlert('warning', 'Document Already Offset', 'You are not allowed to edit this transaction!');
        return;
      }

      this.selectedJournalDetail = [data];
      this.subAction =
        this.action == 'N' ? 'N'
        : data['Action'] && data['Action'] == 'N' ? 'N'
        : 'E';
      this.subtitleJL = 'Edit Journal Detail';

      this.txnDate = data['Txn Date'] ? new Date(data['Txn Date']) : null;
      this.selectedPartyType =
        data['Debtor'].trim() != '' ? this.partyType.find((p) => p.apiKey == '0')
        : data['Creditor'].trim() != '' ? this.partyType.find((p) => p.apiKey == '1')
        : this.partyType.find((p) => p.apiKey == '2');
      this.selectedParty = this.partyItemList.find(
        (p) =>
          p[this.partyItemKey] ==
          (data['Debtor'].trim() != '' ? data['Debtor']
          : data['Creditor'].trim() != '' ? data['Creditor']
          : data['Charges Code']),
      );
      this.selectedJobNo = data['Job No'] ? this.jobNoList.find((j) => j['Job No'] == data['Job No']) : null;
      this.selectedDrAcc = data['Debit Acc'] ? this.glAccList.find((a) => a['Acc No'] == data['Debit Acc']) : null;
      this.selectedCrAcc = data['Credit Acc'] ? this.glAccList.find((a) => a['Acc No'] == data['Credit Acc']) : null;
      this.selectedDocType =
        data['Offset Doc'] && data['Doc Type'] ? this.docType.find((d) => d['type'] == data['Doc Type']) : null;
      if (this.selectedDocType) {
        await this.docTypeSelected(this.selectedDocType, null);
      }
      this.selectedOffsetDoc =
        data['Offset Doc'] ? this.offsetDocList.find((o) => o['Doc No'] == data['Offset Doc']) : null;
      if (this.selectedOffsetDoc) {
        //   this.offsetDocOutstanding = this.getOutstandingBeforeOffset(
        //     this.selectedDocType['apiKey'],
        //     data['TxnInd'],
        //     this.selectedOffsetDoc['Outstanding Amount'],
        //     data['Amount'],
        //     data['Action'],
        //   ).toString();
        this.offsetDocOutstanding = this.$currencyFormat(this.selectedOffsetDoc['Outstanding Amount'] || '0');
      }
      this.txnAmount = data['Amount'] ? (Number(data['Amount']) || 0).toFixed(2) : '0.0000';
      this.txnRemarks = data['Remarks'] || '';
      this.showTxnInput = true;
    },

    // getOutstandingBeforeOffset: function (docType, docInd, outstandingAmt, offsetAmt, subaction) {
    //   if (subaction == 'N') return this.$currencyFormat(outstandingAmt);
    //   let sign = 1;
    //   switch (docType) {
    //     case '0':
    //     case '1':
    //     case '2':
    //     case '5':
    //       if (docInd == '0') sign = -1;
    //       break;

    //     case '3':
    //     case '4':
    //     case '6':
    //       if (docInd == '1') sign = -1;
    //       break;
    //   }

    //   const amount = Number(outstandingAmt) + Number(offsetAmt) * sign;
    //   return this.$currencyFormat(amount);
    // },

    getTxnType: function (partyType, partyGL, debitAcc, creditAcc, amount) {
      /** TxnType
       * 0 - Dr
       * 1 - Cr
       * 2 - No AR/AP
       */
      if (partyType == '2') return;
      let txntype = '2';
      switch (partyType) {
        case '0': {
          // debtor
          if (partyGL != debitAcc && partyGL != creditAcc) {
            txntype = '2';
          } else if (partyGL != debitAcc && partyGL == creditAcc) {
            txntype = Number(amount) >= 0 ? '1' : '0';
          } else {
            txntype = Number(amount) >= 0 ? '0' : '1';
          }
          break;
        }

        case '1': {
          if (partyGL != creditAcc && partyGL != debitAcc) {
            txntype = '2';
          } else if (partyGL != creditAcc && partyGL == debitAcc) {
            txntype = Number(amount) >= 0 ? '0' : '1';
          } else {
            txntype = Number(amount) >= 0 ? '1' : '0';
          }
          break;
        }

        case '2': {
          const creditorGLAcc = this.creditorList.map((cr) => cr['GL Acc']);
          if (!creditorGLAcc.includes(debitAcc) && !creditorGLAcc.includes(creditAcc)) {
            txntype = '2';
          } else if (!creditorGLAcc.includes(debitAcc) && creditorGLAcc.includes(creditAcc)) {
            txntype = Number(amount) >= 0 ? '0' : '1';
          } else {
            txntype = Number(amount) >= 0 ? '1' : '0';
          }
          break;
        }
      }
      return txntype;
    },

    checkJournalDetailsRequiredFields: function () {
      let error = false;

      if (!this.txnDate) {
        this.txnDateErr = 'Date is required!';
        error = true;
      } else if (this.txnDate < new Date('1900-01-01')) {
        this.txnDateErr = 'Invalid Date!';
        error = true;
      } else if (this.txnDate > new Date('2079-06-06')) {
        this.txnDateErr = 'Invalid Date!';
        error = true;
      }

      if (!this.selectedPartyType) {
        this.partyTypeErr = `Please select either ${this.filteredPartyTypePlaceholder}!`;
        error = true;
      } else if (!this.selectedParty) {
        this.partyErr = `${this.partyTypePlaceholder} is required!`;
        error = true;
      }

      if (!this.selectedDrAcc) {
        this.drAccErr = 'Debit Account is required!';
        error = true;
      }

      if (!this.selectedCrAcc) {
        this.crAccErr = 'Credit Account is required!';
        error = true;
      }

      if (this.selectedDocType && !this.selectedOffsetDoc) {
        this.offsetDocErr = 'Offset Doc is required!';
        error = true;
      }

      if (this.selectedPartyType['apiKey'] == '2' && !this.selectedJobNo) {
        this.jobNoErr = 'Job No is required!';
        error = true;
      }

      return error;
    },

    validateJournal: async function (txnType) {
      let error = false;

      // Validate date
      if (this.journalTxnDetails.length > 0) {
        const jlMonth = this.journalDate.split('/')[0];
        const jlYear = this.journalDate.split('/')[1];
        const txnMonth = this.txnDate.formatString('MM');
        const txnYear = this.txnDate.formatString('yyyy');
        if (Number(jlMonth) != Number(txnMonth) && Number(jlYear) != Number(txnYear)) {
          this.txnDateErr = 'Invalid Date!';
          error = true;
        }
      }

      if (!this.selectedOffsetDoc) return error;

      let currentTemp = 0;
      const filter = this.journalTxnDetails.filter(
        (txn) =>
          txn['Offset Doc'] == this.selectedOffsetDoc['Doc No'] &&
          (txn['Action'] == 'N' || txn['Action'] == 'E') &&
          (txn['TxnInd'] == '0' || txn['TxnInd'] == '1'),
      );

      if (
        ['1', '2', '5'].includes(this.selectedDocType['apiKey']) ||
        (this.selectedDocType['apiKey'] == 0 && this.selectedOffsetDoc['TxnInd'] == '0')
      ) {
        const amount = filter.map((txn) => Number(txn['Amount']) * (txn['TxnInd'] == '0' ? -1 : 1));
        currentTemp = amount.reduce((sum, num) => sum + num, 0);
      } else {
        const amount = filter.map((txn) => Number(txn['Amount']) * (txn['TxnInd'] == '1' ? -1 : 1));
        currentTemp = amount.reduce((sum, num) => sum + num, 0);
      }

      if (this.selectedDocType['apiKey'] != '0') {
        if (this.subAction == 'E') {
          const selectedJLAmt = Number(this.selectedJournalDetail[0]['Amount']);
          if (
            ['1', '2', '5'].includes(this.selectedDocType['apiKey']) ||
            (this.selectedDocType['apiKey'] == 0 && this.selectedOffsetDoc['TxnInd'] == '0')
          ) {
            currentTemp +=
              selectedJLAmt *
              (this.selectedJournalDetail[0]['TxnInd'] == '0' ? 1
              : this.selectedJournalDetail[0]['TxnInd'] == '1' ? -1
              : 0);
          } else {
            currentTemp += selectedJLAmt * (this.selectedJournalDetail[0]['TxnInd'] == '1' ? 1 : -1);
          }
        }

        if (
          this.selectedDrAcc['Acc No'] == this.gainAcc ||
          this.selectedDrAcc['Acc No'] == this.lossAcc ||
          this.selectedCrAcc['Acc No'] == this.gainAcc ||
          this.selectedCrAcc['Acc No'] == this.lossAcc
        ) {
          if (Number(this.txnAmount) < 0) {
            const actualOutstanding = Number(this.selectedOffsetDoc['Ori Outstanding']) + currentTemp;
            if (Number(this.txnAmount) < actualOutstanding) {
              this.txnAmountErr = `Amount is greater than outstanding amount (${this.$currencyFormat(actualOutstanding)})!`;
              error = true;
            }
          } else {
            const actualOutstanding = Number(this.selectedOffsetDoc['Ori Outstanding']) - currentTemp;
            if (Number(this.txnAmount) > actualOutstanding) {
              this.txnAmountErr = `Amount is greater than outstanding amount (${this.$currencyFormat(actualOutstanding)})!`;
              error = true;
            }
          }
        } else {
          // The rule of thumb is that the outstanding amount of the documents after offset should not be negative.
          const actualOutstanding = parseFloat(this.selectedOffsetDoc['Ori Outstanding']) - currentTemp;
          if (actualOutstanding - Number(this.txnAmount) < 0) {
            this.txnAmountErr = `Amount is greater than outstanding amount (${this.$currencyFormat(actualOutstanding)})!`;
            error = true;
          }
        }
      } else if (
        this.selectedDocType['apiKey'] == '0' &&
        txnType == '0' &&
        Number(this.selectedOffsetDoc['Ori Outstanding']) >= 0
      ) {
        await this.$showAlert('error', 'Invalid Offset', 'Cannot offset same nature (Debit)');
        error = true;
      } else if (
        this.selectedDocType['apiKey'] == '0' &&
        txnType == '1' &&
        Number(this.selectedOffsetDoc['Ori Outstanding']) <= 0
      ) {
        await this.$showAlert('error', 'Invalid Offset', 'Cannot offset same nature (Credit)');
        error = true;
      }
      return error;
    },

    addEditDetailsClicked: async function () {
      if (this.checkJournalDetailsRequiredFields()) return;

      const txnType = this.getTxnType(
        this.selectedPartyType['apiKey'],
        this.selectedParty['GL Acc'],
        this.selectedDrAcc['Acc No'],
        this.selectedCrAcc['Acc No'],
        this.txnAmount,
      );

      if (await this.validateJournal(txnType)) return;
      if (Number(this.txnAmount) < 0) {
        const proceed = await this.$showAlert(
          'warning',
          'Amount is Negative',
          'Debit Account and Credit Account will be swapped, and the amount will be converted to positive. Proceed? ',
          [{ text: 'Yes', color: 'red', textColor: 'white' }, { text: 'No' }],
        );

        if (proceed == 'No') return;
      }
      const temp = this.journalTxnDetails;

      if (txnType == '2' && this.selectedOffsetDoc) {
        this.$showAlert(
          'error',
          'Invalid Debit/Credit Account',
          'Cannot offset with current non-debtor/creditor in Debit/Credit Account.',
        );
        return;
      }

      const drToSave = Number(this.txnAmount) <= 0 ? this.selectedCrAcc : this.selectedDrAcc;
      const crToSave = Number(this.txnAmount) <= 0 ? this.selectedDrAcc : this.selectedCrAcc;
      const allTxn = this.journalTxnDetails.concat(this.deletedJournalTxnDetails);
      const highestSeq = allTxn.length > 0 ? Math.max(...allTxn.map((txn) => Number(txn['Seq No']))) : 0;
      const dataToAdd = {
        BatchNo: '',
        'Seq No': (highestSeq + 1).toString(),
        Action: this.subAction,
        'Txn Date': this.txnDate ? this.txnDate.formatString('yyyy-MM-dd') : '',
        Debtor: this.selectedPartyType['apiKey'] == '0' ? this.selectedParty[this.partyItemKey] : '',
        Creditor: this.selectedPartyType['apiKey'] == '1' ? this.selectedParty[this.partyItemKey] : '',
        'Charges Code': this.selectedPartyType['apiKey'] == '2' ? this.selectedParty[this.partyItemKey] : '',
        'Debit Acc': drToSave ? drToSave['Acc No'] : '',
        'Credit Acc': crToSave ? crToSave['Acc No'] : '',
        Amount: parseFloat(this.txnAmount || 0) * (Number(this.txnAmount) <= 0 ? -1 : 1),
        'Job No': this.selectedJobNo ? this.selectedJobNo['Job No'] : '',
        Remarks: this.txnRemarks,
        Txn: this.selectedDocType ? this.selectedDocType['apiKey'] : '0',
        'Offset Doc': this.selectedOffsetDoc ? this.selectedOffsetDoc['Doc No'] : '',
        'Doc Type': this.selectedOffsetDoc && this.selectedDocType ? this.selectedDocType['type'] : '',
        TxnInd: txnType,
        'User ID': '',
        'Date Updated': '',
      };

      if (this.selectedJournalDetail.length > 0) {
        dataToAdd['BatchNo'] = this.batchNo;
        dataToAdd['Seq No'] = this.selectedJournalDetail[0]['Seq No'];
        const index = temp.findIndex((item) => item['Seq No'] == this.selectedJournalDetail[0]['Seq No']);
        temp.splice(index, 1, dataToAdd);
      } else {
        temp.push(dataToAdd);
      }

      this.journalTxnDetails = [];
      this.$nextTick(() => {
        this.selectedJournalDetail = [];
        this.journalTxnDetails = temp;
        this.showTxnInput = false;
        this.clearAllDetailsData();
        this.updateJournalTotal();
      });
    },

    cancelDetailsClicked: function () {
      this.clearAllDetailsData();
      this.showTxnInput = false;
    },

    jobnoRowLimitChanged: async function (focus) {
      if (!focus) {
        this.$fullscreenLoading('Getting Job No');
        this.jobNoList = [];
        this.jobNoList = await this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'JOB',
          toprow: this.jobNoRowLimit,
        });
        this.$fullscreenLoading();
      }
    },

    txnAmountFocusChanged: function (focus) {
      if (!focus) {
        this.txnAmount = (parseFloat(this.txnAmount) || 0).toFixed(2);
      }
    },
    //#endregion

    //#region Attachment Tab Functions
    openAttachmentPopup: function (action) {
      this.clearAllAttData();
      switch (action) {
        case 'new':
          this.attachmentsAction = 'N';
          this.selectedAtt = [];
          this.attachmentsPopupButtons = [{ text: 'Add' }, { text: 'Cancel', color: 'lightgray' }];
          this.attachmentsPopupTitle = 'Add Attachment';
          break;

        case 'edit':
          if (this.selectedAtt.length == 0) {
            this.$showAlert('error', 'No Attachment Selected', 'Please select an Attachment to edit');
            return;
          }
          this.attachmentsAction = 'E';
          this.attachmentsPopupButtons = [{ text: 'Edit' }, { text: 'Cancel', color: 'lightgray' }];
          this.attachmentsPopupTitle = 'Edit Attachment';

          this.documents = {
            docName: this.selectedAtt[0]['File Name'],
            attachementFile: this.selectedAtt[0]['Doc Image'],
            filetype: this.selectedAtt[0]['File Type'],
            docGuid: this.selectedAtt[0]['Document GUID'],
            remarks: this.selectedAtt[0]['Doc Remark'],
            docID: this.selectedAtt[0]['ID'],
          };
          break;
      }
      this.showAttachmentsPopup = true;
    },

    deleteAttachmentClicked: async function () {
      if (this.selectedAtt.length == 0) {
        this.$showAlert('error', 'No Document Selected', 'Please select at least 1 document to delete');
        return;
      }

      const confirmCancel = await this.$showAlert(
        'warning',
        'Deleting Attachment',
        `Are you sure you want to delete this attachment ?`,
        [
          { text: 'Yes', color: 'red', textColor: 'white' },
          { text: 'No', color: 'lightgray', textColor: 'black' },
        ],
      );
      if (confirmCancel == 'No') return;

      let existingData = false;
      const tempDeleted = this.deletedAttList;
      this.deletedAttList = [];

      for (const d of this.selectedAtt) {
        const doc = {
          Action: 'D',
          'Document GUID': d['Document GUID'],
        };

        if (d['Document GUID']) {
          tempDeleted.push(doc);
          existingData = true;
        }
      }

      const temp = this.attachmentsList;
      const index = temp.findIndex((item) => {
        return existingData ?
            item['Document GUID'] == this.selectedAtt[0]['Document GUID']
          : item['ID'] == this.selectedAtt[0]['ID'];
      });
      temp.splice(index, 1);
      this.attachmentsList = [];

      this.$nextTick(() => {
        this.deletedAttList = tempDeleted;
        this.attachmentsList = temp;
        this.selectedAtt = [];
      });
    },

    attAdditionalBtnsClicked: async function (btn, data) {
      switch (btn) {
        case 'View':
          this.attachmentsAction = 'V';
          this.selectedAtt = [data];
          await this.projectAttachment({
            'File Name': data['File Name'],
            'MIME Type': null,
            'File Data': data['Doc Image'],
          });
          break;
      }
    },

    attachmentsPopupBtnsClicked: async function (btn) {
      let temp;
      let highestID = 1;
      let doc = null;

      switch (btn) {
        case 'Add':
          if (!this.documents['docName']) {
            this.attachmentsRequiredErrorMessage = 'Please attach at least one file';
            return;
          }

          if (this.attachmentsList.length > 0) {
            let duplicate = false;
            this.attachmentsList.forEach((d) => {
              if (d['File Name'] === this.documents['docName']) duplicate = true;
            });

            if (duplicate) {
              await this.$showAlert('error', 'Selected file already exist!', 'Please select other attachment');
              return;
            }
          }

          temp = [...this.attachmentsList];
          this.attachmentsList = [];
          highestID = temp.reduce((max, d) => (d['ID'] > max ? d['ID'] : max), 1);

          doc = {
            Action: 'N',
            'Doc Remark': this.documents['remarks'] ? this.documents['remarks'] : '',
            'Doc Date': new Date().formatString('yyyy-MM-dd'),
            'File Name': this.documents['docName'] ? this.documents['docName'] : '',
            'File Type': this.documents['fileType'] ? this.documents['fileType'] : '',
            'Doc Image': this.documents['attachmentFile'] ? this.documents['attachmentFile'] : '',
            'Document GUID': this.documents['docGuid'] ? this.documents['docGuid'] : '',
            ID: this.documents['docID'] ? this.documents['docID'] : ++highestID,
            _attachmentAction: 'New',
          };

          this.$nextTick(() => {
            temp.push(doc);
            this.attachmentsList = temp;
            this.oldDoc = this.documents['docName'];
            this.clearAllAttData();
          });
          this.showAttachmentsPopup = false;
          break;

        case 'Edit': {
          if (this.attachmentsList.length > 0) {
            let duplicate = false;
            this.attachmentsList.forEach((d) => {
              if (
                d['File Name'] === this.documents['docName'] &&
                this.documents['docName'] != this.selectedAtt[0]['File Name']
              )
                duplicate = true;
            });

            if (duplicate) {
              this.$showAlert('error', 'Selected file already exist!', 'Please select other attachment');
              return;
            }
          }
          temp = [...this.attachmentsList];
          highestID = temp.reduce((max, d) => (d['ID'] > max ? d['ID'] : max), 1);

          let existingData = false;
          for (const d of this.selectedAtt) {
            doc = {
              Action: d['Action'] ? d['Action'] : 'E',
              'Doc Remark': this.documents['remarks'] ? this.documents['remarks'] : '',
              'Doc Date': new Date().formatString('yyyy-MM-dd'),
              'File Name': this.documents['docName'] ? this.documents['docName'] : '',
              'File Type': this.documents['filetype'] ? this.documents['filetype'] : '',
              'Doc Image': this.documents['attachmentFile'] ? this.documents['attachmentFile'] : '',
              'Document GUID': this.documents['docGuid'] ? this.documents['docGuid'] : '',
              ID: this.documents['docID'] ? this.documents['docID'] : ++highestID,
            };

            if (d['Document GUID']) existingData = true;
          }

          const temp2 = this.attachmentsList;
          const index = temp2.findIndex((item) => {
            return existingData ?
                item['Document GUID'] == this.selectedAtt[0]['Document GUID']
              : item['ID'] == this.selectedAtt[0]['ID'];
          });

          temp2.splice(index, 1, doc);
          this.attachmentsList = [];
          this.$nextTick(() => {
            this.oldDoc = this.documents['docName'];
            this.attachmentsList = temp2;
            this.clearAllAttData();
          });
          this.showAttachmentsPopup = false;
          break;
        }

        case 'Cancel':
          this.showAttachmentsPopup = false;
          this.clearAllAttData();
          break;
      }
    },

    handleFileUpload: async function (file) {
      if (file.length == 0) {
        this.documents['docName'] = '';
        this.documents['fileType'] = '';
        this.documents['attachmentFile'] = '';
      } else {
        this.$fullscreenLoading('Adding File');
        this.documents['docName'] = file[0].name;
        this.documents['fileType'] = file[0].name.substring(file[0].name.indexOf('.'));
        const tempAtt = await file[0].toBase64();
        this.documents['attachmentFile'] = tempAtt.substring(tempAtt.indexOf(',') + 1);
        this.attachmentsRequiredErrorMessage = '';
        this.$fullscreenLoading();
      }
    },

    projectAttachment: async function (file) {
      if (!file && process.env['NODE_ENV'] == 'development') {
        throw new Error('No file was passed to projectAttachment. Check for logic errors');
      }

      this.$fullscreenLoading('Preparing file');
      if (file instanceof File) {
        this.attachmentProjectorFileName = file['name'];
        this.attachmentProjectorType = file['type'];
        this.attachmentProjectorData = URL.createObjectURL(file);
      } else {
        this.attachmentProjectorFileName = file['File Name'];
        this.attachmentProjectorType =
          file['MIME Type'] ||
          (await this.$apiCallV2(`/Receipt/GetMIMEType?filename=${this.attachmentProjectorFileName}`));

        const byteCharacters = atob(
          file['File Data'].startsWith('data:') ? file['File Data'].split(',')[1] : file['File Data'],
        );

        const untypedByteArray = [];
        for (let i = 0; i < byteCharacters.length; i++) {
          untypedByteArray.push(byteCharacters.charCodeAt(i));
        }

        const blob = new Blob([new Uint8Array(untypedByteArray)], { type: this.attachmentProjectorType });
        this.attachmentProjectorData = URL.createObjectURL(blob);
      }

      this.isProjectable = this.attachmentProjectable();
      this.showAttachmentProjector = true;
      this.$fullscreenLoading();
    },

    attachmentProjectable: function () {
      if (!this.attachmentProjectorFileName || !this.attachmentProjectorType) {
        return false;
      }

      const fileNameSplit = this.attachmentProjectorFileName.trim().split('.');
      const fileExtension = fileNameSplit[fileNameSplit.length - 1];
      const projectableExtensions = ['pdf', 'txt', 'json', 'mp3', 'wav', 'mp4', 'webm', 'ogg'];
      return this.attachmentProjectorType.startsWith('image/') || projectableExtensions.includes(fileExtension);
    },

    downloadAttachment: function () {
      const anchor = document.createElement('a');
      anchor['href'] = this.attachmentProjectorData;
      anchor['download'] = this.selectedAtt[0]['File Name'];
      anchor.click();
    },

    closeProjector: function () {
      this.attachmentProjectorType = '';
      this.attachmentProjectorData = '';
      this.showAttachmentProjector = false;
    },
    //#endregion
  },
  async mounted() {
    let sas = [];
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Journal') {
        sas = x['data'];
      }
    });

    let enableRecovery = false;
    const mountedPromises = [];
    let mountedPromisesFulFilledCount = 0;

    mountedPromises.push(
      this.$apiCallV2('/Journal/GetJournalDocLists', { category: '2', payeetype: '0' }).then((result) => {
        this.debtorList = result;
        this.$topLoading(++mountedPromisesFulFilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CREDITOR' }).then((result) => {
        this.creditorList = result;
        this.$topLoading(++mountedPromisesFulFilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'GROUPCODE' }).then((result) => {
        this.groupCodeList = result;
        this.$topLoading(++mountedPromisesFulFilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'JOB', toprow: this.jobNoRowLimit }).then((result) => {
        this.jobNoList = result;
        this.$topLoading(++mountedPromisesFulFilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'GLACCOUNT' }).then((result) => {
        this.glAccList = result;
        this.$topLoading(++mountedPromisesFulFilledCount / mountedPromises.length);
      }),
    );

    for (const doc of this.docType) {
      const dataToPost = {
        doctype: doc['apiKey'],
        category: '1',
      };
      mountedPromises.push(
        this.$apiCallV2('/Journal/GetJournalDocLists', dataToPost).then((result) => {
          this.journalItems[doc['type']] = result;
          this.$topLoading(++mountedPromisesFulFilledCount / mountedPromises.length);
        }),
      );
    }

    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=6G_JournalRecovery').then((result) => {
        enableRecovery = result[0].SettingsValue === '1';
        this.$topLoading(++mountedPromisesFulFilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=EXCHANGEGAIN').then((result) => {
        this.gainAcc = result[0].SettingsValue;
        this.$topLoading(++mountedPromisesFulFilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=EXCHANGELOSS').then((result) => {
        this.lossAcc = result[0].SettingsValue;
        this.$topLoading(++mountedPromisesFulFilledCount / mountedPromises.length);
      }),
    );

    await Promise.allSettled(mountedPromises).then(async (_promiseOutcomes) => {
      this.menu = this.menu.map((menu) => ({
        ...menu,
        enabled: menu['key'] != 'mnuJournal',
      }));

      sas.forEach((k) => {
        const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] != 'False';
        }
      });

      await this.refreshClicked();

      this.partyType.find((r) => r['apiKey'] == '2').enabled = enableRecovery;

      const cocode = (await this.$apiCallV2('/Login/GetDetails'))?.CoCode;
      const companyDetails = (
        await this.$apiCallV2('/Master/GetDetailsMaster', { masterfile: 'COMPANY', recordid: cocode })
      )['Company'];
      this.debtorCtrlAcc = companyDetails['DebtorCtrlAcc'];
      this.creditorCtrlAcc = companyDetails['CreditorCtrlAcc'];
    });
  },
  watch: {
    journalTxnDetails: {
      handler: function (val) {
        if (val.length > 0) {
          const firstTxn = val[0];
          const firstDate = firstTxn['Txn Date'];
          this.journalDate = firstDate ? new Date(firstDate).formatString('MM/yyyy') : '';
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.journal-main {
  display: flex;
  font-size: 12px;
  padding: 10px 45px;

  > .left-menu {
    display: flex;
    justify-content: center;
  }

  > .right-container {
    width: 100%;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    > .top-section,
    > .bottom-section {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
    }

    > .top-section {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      > .filter-desc {
        padding-right: 8px;
      }
    }

    > .bottom-section {
      height: calc(100% - 38px - 5px);
      margin-top: 5px;
    }
  }

  > .attachments-popup-container {
    > .attachments-popup {
      ::v-deep {
        // deep needed to target the content class inside the PopupV2 component
        .content {
          // NOT the content class for slot, but content class inside PopupV2 itself
          overflow: visible;
        }
      }

      .attachments-popup-content {
        overflow: visible;

        > .attached-file {
          text-align: left;
          margin-bottom: 8px;

          > .file-link {
            cursor: pointer;
            user-select: none;

            &:hover {
              text-decoration: underline;
            }

            &:active {
              background-color: black;
              color: white;
            }
          }
        }
      }
    }
  }

  > .attachment-projector {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;

    > .attachment-projection {
      height: 95%;
      width: 80%;

      > object {
        height: 100%;
        width: 100%;
        object-fit: scale-down;
      }

      > .attachment-not-projectable-container {
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-size: 40px;

        > span {
          margin: 10px 0 10px 0;
          color: white;
        }

        > button {
          height: 50px;
          width: 150px;
          margin: 10px 0 10px 0;
          font-size: 16px;

          > img {
            height: 24px;
            width: 24px;
          }
        }
      }
    }

    > .close-button {
      height: 50px;
      width: 50px;
      position: absolute;
      top: 10px;
      right: 10px;
      border-radius: 100px;
      background-color: white;
      text-align: center;
      font-size: xx-large;
      cursor: pointer;
      user-select: none;
    }
  }
}

.button-filter-component {
  margin-right: 5px;
  position: relative;

  .filter-popup {
    display: flex;
    flex-direction: column;
    z-index: 10;

    > button {
      margin-top: 5px;
      width: fit-content;
      align-self: flex-end;
    }
  }
}

.journal-entries {
  height: calc(100% - 27px);
  width: 100%;
  overflow: scroll;

  .journal-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    > .header-containers {
      width: 100%;
      margin-right: 5px;
    }
  }
}

.tab-slot {
  display: flex;
  height: 100%;

  > .tab-details-styling {
    margin-right: 3px;
    height: 100%;
    overflow: scroll;

    .tab-buttons {
      display: flex;
      flex-direction: row;
      margin: 5px 5px;
      align-items: center;

      > button {
        margin-right: 5px;
        height: fit-content;
      }
    }
  }

  > .side-entry-open {
    height: 100%;
    border-left: 1px solid black;
    overflow: scroll;
    margin-left: 5px;
    padding-left: 10px;

    .title-button {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 50px;
      margin: 5px 0px;
      padding: 5px 0px;

      .buttons-arr {
        display: flex;

        button {
          margin-right: 5px;
          height: fit-content;
        }
      }
    }
  }
}

.foreign-currency-main {
  font-size: 12px;
  padding: 10px;
  border-radius: 10px;
  position: relative;
  background-color: rgb(225, 255, 255);
}

.foreign-currency-controls {
  position: relative;
  z-index: 101;
}

.foreign-currency-row {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;

  > :not(:first-child) {
    margin-left: 5px;
  }

  > .foreign-currency-column {
    flex: 1;
  }
}

.foreign-currency-background {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  z-index: 1;

  > .background-left {
    width: 50%;
    border-right: 3px solid white;
  }

  > .background-right {
    width: 50%;
    border-left: 3px solid white;
  }
}

.total-block {
  border: 1px solid rgba(128, 128, 128, 0.5);
  padding: 5px 10px;
  align-content: space-evenly;
  min-width: 210px;
  padding-right: 5px;
  display: inline;
  text-align: right;
}
</style>
